export default __webpack_public_path__ + "static/media/788.ab6f7fa5.png";